module.exports = __webpack_public_path__ + "img/portugal.2a5ba7ed.png";